import { NextPage } from 'next';
import { useEffect } from 'react';
import { redirectToLogin } from '@utils/redirect';
import { useAuthentication } from '@context/businessContainer';
import { useRouter } from 'next/router';
import { LFLayoutPage } from '@utils/layout';

const withAuthentication = <P extends object, IP = P>(
  WrappedComponent: LFLayoutPage<P, IP> | NextPage<P, IP>,
  redirectFunction?: () => void,
) => {
  const WithAuthentication: LFLayoutPage<P> = (props) => {
    const { isAuthenticated, isLoading, isLogoutPending } = useAuthentication();
    const router = useRouter();

    useEffect(() => {
      const referrer = router?.asPath;

      if (!isLoading && !isAuthenticated && !isLogoutPending) {
        redirectFunction ? redirectFunction() : redirectToLogin(referrer);
      }
    }, [isAuthenticated, isLoading, router?.asPath]);

    if (isLoading || !isAuthenticated) {
      return null;
    }

    return <WrappedComponent {...props} />;
  };

  for (const property in WrappedComponent) {
    WithAuthentication[property] = WrappedComponent[property];
  }

  return WithAuthentication;
};

export default withAuthentication;
